<template>
  <div>
    <Breadcrumbs :title="$t('purchases.allarm')" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <h2>{{ $t('purchases.allarm') }}</h2>
      <div class="row">
        <div class="col-lg-8">
          <div
            v-if="purchases.length<1"
            class="alert alert-info"
          >
            {{ $t('purchases.heBirUurluAlMliyyatQeydAlnmamdr') }}
          </div>

          <div
            v-for="(o,i) in purchases"
            :key="i"
            class="card"
          >
            <div
              class="card-body"
              @click.prevent="$router.push(`/dashboard/request/${o.request.id}`)"
            >
              <div class="row">
                <div class="col-6">
                  <p class="lead">
                    {{ $t('offersList.soru') }}
                  </p>

                  #{{ o.request.requestType }}{{ buildLongId(o.request.id) }}
                  <code><em>{{ getMoment(o.request.logTime) }}</em></code>

                  <div class="mb-2 lead font-weight-bold">
                    {{ o.request.title }}
                  </div>
                </div>

                <div class="col-6">
                  <p class="lead">
                    {{ $t('purchases.qalib') }}
                  </p>

                  <div class="d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center">
                      <div class="mr-2">
                        <img
                          :src="getPhoto(o.user.photo,'thumbnailCropped')"
                          class="img-thumbnail rounded-circle"
                          style="height: 50px;"
                        >
                      </div>
                      <div>
                        <span class="text-dark">
                          {{ o.user.name }}  {{ o.user.surname }}
                        </span> <code><em>{{ getMoment(o.logTime) }}</em></code> <br>
                        <span class="text-primary ">
                          {{ o.company.name }} {{ getCompanyFormat(o.company.format) }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <hr class="p-0 m-0">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <p class="lead">
                    {{ $t('purchases.qiymtlndirm') }}
                  </p>

                  <div v-if="o.supplyRate === null && openRateBlock !== o.id">
                    <a
                      class="btn btn-warning"
                      @click.prevent="openRateBlock = o.id"
                    >{{ $t('purchases.dyrlndir2') }}</a>
                  </div>
                  <div v-else-if="o.supplyRate">
                    <div class="text-warning">
                      <i
                        v-for="i in 5"
                        :key="i"
                        :class="['fa', 'fa-2x', o.supplyRate>=i?'fa-star':'fa-star-o']"
                      />
                      <span class="h3 ml-3">{{ o.supplyRate.toFixed(1) }}</span>
                    </div>
                    <code><em> {{ getMoment(o.request.supplyRatetime) }}</em></code>
                    <div class="lead">
                      {{ o.supplyRateComment }}
                    </div>
                  </div>
                  <div v-else-if="openRateBlock === o.id">
                    <form @submit.prevent="submitRateOrderForm(o.id)">
                      <div class="mb-3">
                        <label>{{ $t('purchases.rating') }}</label>

                        <div class="text-warning">
                          <i
                            :class="['fa', 'fa-3x', rate>0?'fa-star':'fa-star-o']"
                            @click="rate=1"
                          />
                          <i
                            :class="['fa', 'fa-3x', rate>1?'fa-star':'fa-star-o']"
                            @click="rate=2"
                          />
                          <i
                            :class="['fa', 'fa-3x', rate>2?'fa-star':'fa-star-o']"
                            @click="rate=3"
                          />
                          <i
                            :class="['fa', 'fa-3x', rate>3?'fa-star':'fa-star-o']"
                            @click="rate=4"
                          />
                          <i
                            :class="['fa', 'fa-3x', rate>4?'fa-star':'fa-star-o']"
                            @click="rate=5"
                          />
                        </div>
                      </div>

                      <div class="mb-3">
                        <label>{{ $t('purchases.qeydiniz') }}</label>
                        <textarea
                          v-model="rateComment"
                          class="form-control"
                          required
                        />
                      </div>

                      <div class="my-3">
                        <button
                          type="submit"
                          class="btn btn-success mr-3"
                        >
                          {{ $t('purchases.dyrlndir') }}
                        </button>
                        <button
                          type="submit"
                          class="btn btn-outline-secondary"
                          @click="openRateBlock=0"
                        >
                          {{ $t('companyProfile.lvEt2') }}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
                <div class="col-md-6">
                  <p class="lead">
                    {{ $t('purchases.alMbli') }}
                  </p>

                  <p>
                    {{ $t('purchases.sorunuDanqlarSasndaHansQiymtlYekunRazladrdnzsaHmin') }}
                  </p>
                  <div v-if="openAmountBlock !== o.id">
                    <div v-if="o.amount <=0">
                      <a
                        class="btn btn-primary"
                        @click.prevent="openAmountBlock = o.id; "
                      >
                        {{ $t('purchases.mbliBildir') }}
                      </a>
                      <p
                        v-if="o.request.requestType==='PQT'"
                        class="text-danger"
                      >
                        {{ $t('purchases.oneOrMore') }}
                      </p>  
                    </div>
                    <div v-else-if="o.amount>0">
                      <code><em>{{ getMoment(o.amountTime) }}</em></code>
                      <div class="lead">
                        {{ $t('purchases.oamountAzn', {amount:o.amount}) }}
                      </div>
                      <div>
                        <a
                          class="text-primary pointer"
                          @click.prevent="openAmountBlock = o.id; amount = o.amount;"
                        >
                          {{ $t('purchases.mbliDyi') }}
                        </a>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <form @submit.prevent="submitAmountForm(o.id)">
                      <div class="mb-3">
                        <label>{{ $t('purchases.mbl') }}</label>
                        <div class="input-group">
                          <input
                            v-model="amount"
                            type="number"
                            min="0"
                            step="0.01"
                            class="form-control"
                            required
                          >
                          <div class="input-group-append">
                            <div class="input-group-text">
                              {{ $t('newAUCRequest.azn') }}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="my-3">
                        <button
                          type="submit"
                          class="btn btn-success mr-3"
                        >
                          {{ $t('sectorSelectionModal.yaddaSaxla') }}
                        </button>
                        <button
                          type="submit"
                          class="btn btn-outline-secondary"
                          @click="openAmountBlock=0"
                        >
                          {{ $t('companyProfile.lvEt2') }}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="company"
          class="col-lg-4"
        >
          <div class="card">
            <div class="card-body">
              <div class="media align-items-center">
                <img
                  class="rounded-circle user-image border mr-2"
                  :src="getPhoto(company.logo,'thumbnailCropped')"
                  alt=""
                  style="width: 60px"
                >
                <div class="about">
                  <div class="name f-w-600">
                    {{ company.name }} {{ getCompanyFormat(company.format) }}
                  </div>
                  <div class="status">
                    {{ company.taxId }}
                  </div>
                </div>
              </div>

              <p class="mt-2">
                {{ $t('dashboardActiveCompanyCard.sizHazrdaIrktind', {name: company.name, getCompanyFormat: getCompanyFormat(company.format)}) }}
                <strong> {{ getProfileName(profile) }} </strong> {{ $t('dashboardActiveCompanyCard.profilid') }} <strong>{{ position }}</strong>
                {{ $t('dashboardActiveCompanyCard.vzifsindFaliyytGstrirsiniz') }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>
<script>
import {mapState} from "vuex";
import {
  getPurchases, rateOffer, setWinnerAmount
} from "@/repositories/GeneralDataRepository";
import {mediaBase} from "@/repositories/Repository";
import {
  buildLongId,
  getCompanyFormat,
  getPhoto,
  getProfileName
} from "@/repositories/Utils";
import moment from "moment/moment";
import { handleErrors } from "@/repositories/VendorManagementRepository";


export default {
  data() {
    return {
      mediaBase: mediaBase,
      purchases: [],
      openRateBlock: 0,
      rate: 0,
      rateComment: '',

      openAmountBlock: 0,
      amount: 0
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
      company: state => state.auth.company,
      sessionType: state => state.auth.sessionType,
      profile: state => state.auth.profile,
      position: state => state.auth.position,
    }),
  },
  mounted() {

    this.getPurchases();

  },
  methods: {
    getMoment(time) {
      moment.locale(this.$i18n.locale);
      return moment(new Date(time)).format('DD MMM YYYY HH:mm')
    },
    getPhoto(path, size, defaultPhoto) {
      return getPhoto(path, size, defaultPhoto);
    },
    getProfileName(keyword) {
      return getProfileName(keyword,this.i18n);
    },
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },
    buildLongId(id) {
      return buildLongId(id, 5);
    },
    getPurchases() {
      getPurchases(this.token).then(data => {
        if (data.code === 200) {
          this.purchases = data.purchases;
        } else {
          this.$router.push({name: 'changeAccount', query: {next: '/dashboard/purchases'}});
        }
      })
    },
    submitRateOrderForm(id) {

      if (this.rate > 0) {

        rateOffer(this.token, id, this.rate, this.rateComment).then(data => {

          if (data.code === 200) {
            this.$swal({
              title: this.$t("tskkrlr"),
              text: this.$t("purchases.qeydeAlindi"),
              icon: 'success'
            })
            this.getPurchases();
            this.openRateBlock = 0;
            this.rate = 0;
            this.rateComment = '';
          } else {
            this.$swal({
              title: `Error ${data.code}`,
              text: `${data.message}`,
              icon: 'error'
            })
          }
        })
      } else {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("purchases.ulduzlar"),
          icon: 'warning'
        })
      }

    },
    submitAmountForm(id) {


      setWinnerAmount(this.token, id, this.amount).then(data => {

        if (data.code === 200) {
          this.$swal({
            title: this.$t("tskkrlr"),
            text: this.$t("purchases.qeydeAlindi"),
            icon: 'success'
          })
          this.getPurchases();
          this.openAmountBlock = 0;
          this.amount = 0;
        } else if (data.code === 403) {
          // Handle 403 error
          handleErrors(this.$swal, data, () => {
            // Optional callback after error is displayed
          });
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          })
        }
      })

    }
  }


}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>
